import { Component, OnInit, Pipe, PipeTransform } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {
  NgbCalendar,
  NgbDate,
  NgbDatepickerConfig,
  NgbDateStruct
} from "@ng-bootstrap/ng-bootstrap";
import { userDetailsService } from "src/app/services/user.details.service";
import { Country, State, City } from "country-state-city";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
// import { isEmpty, __ } from "lodash";
import * as _ from "lodash";
import Swal from "sweetalert2";
import * as moment from "moment";
 
@Component({
  selector: "app-user-details",
  templateUrl: "./user-details.component.html",
  styleUrls: ["./user-details.component.scss"]
})
export class UserDetailsComponent implements OnInit {
  userForm: FormGroup;
  addressForm: FormGroup;
  schoolInfoForm: FormGroup;
  personalInfoForm: FormGroup;
  socialMediaForm: FormGroup;
  submitted = false;
  allComplete: boolean = false;
  useDifferentAddress: boolean = false;
  time = 600000;
  // time = 30000;
 
  model: NgbDateStruct;
  today = this.calendar.getToday();
 
  userInfo = {
    userId: "",
    dob: "",
    name: "",
    fatherName: "",
    fatherOccupation: "",
    motherName: "",
    motherOccupation: ""
  };
 
  addressInfo = {
    street: "",
    city: "",
    state: "",
    pincode: "",
    permanentStreet: "",
    permanentCity: "",
    permanentState: "",
    permanentPincode: ""
  };
 
  states: any;
  cities: any;
  permanentCities: any;
  highSchoolCities: any;
  schoolCities: any;
  countDown: any;
  counter: number;
  localUserInfo: any;
  localSchoolInfo: any;
  localAddressInfo: any;
  localPersonalInfo: any;
  localSocialMediaInfo: any;
  timeout: NodeJS.Timer;
  sessionUserId: string;
  data: any = {};
  address: string;
  permanentAddress: string;
  school: string;
  highSchool: string;
  updatedAddress: any;
  updatedPermanentAddress: any;
  state: any;
  personalDetailsResult: any;

  // Badge/chip arrays for multi-value fields
  favSchoolSubjects: string[] = [];
  favCollegeSubjects: string[] = [];
  socialMediaApps: string[] = [];

  // Temporary input values
  tempSchoolSubject: string = "";
  tempCollegeSubject: string = "";
  tempSocialMediaApp: string = "";

  // Date Of Birth
  minDate: NgbDateStruct = { year: 1980, month: 1, day: 1 }; // Adjust as needed
  maxDate: NgbDateStruct = { 
    year: new Date().getFullYear() - 14, // e.g., must be 14+ years old
    month: 12, 
    day: 31 
  };

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private userDetails: userDetailsService,
    private calendar: NgbCalendar
  ) {}
 
  ngOnInit() {
    // this.timeout = setTimeout(() => {
    //   this.router.navigateByUrl('/instruction');
    // }, this.time);
 
    this.userForm = this.formBuilder.group(
      {
        name: [{ value: "", disabled: true }],
        dob: ["", Validators.required],
        fatherName: ["", [Validators.required, Validators.minLength(2)]],
        fatherOccupation: ["", [Validators.required, Validators.minLength(2)]],
        motherName: ["", [Validators.required, Validators.minLength(2)]],
        motherOccupation: ["", [Validators.required, Validators.minLength(2)]]
      },
      { updateOn: "change" }
    );
 
    this.addressForm = this.formBuilder.group({
      street: ["", [Validators.required]],
      city: ["", Validators.required],
      state: ["", [Validators.required]],
      pincode: [
        "",
        [
          Validators.required,
          Validators.minLength(5),
          Validators.pattern("^[0-9]*$"),
          Validators.maxLength(7)
        ]
      ],
      permanentStreet: [""],
      permanentCity: [""],
      permanentState: [""],
      permanentPincode: [""]
    });
 
    this.schoolInfoForm = this.formBuilder.group({
      schoolName: ["", Validators.required],
      schoolCity: ["", Validators.required],
      schoolState: ["", [Validators.required]],
      highSchoolName: ["", [Validators.required, Validators.minLength(2)]],
      highSchoolCity: ["", [Validators.required]],
      highSchoolState: ["", [Validators.required]],
      favSchoolSubject: ["", [Validators.required, Validators.minLength(3)]],
      favCollegeSubject: ["", [Validators.required, Validators.minLength(3)]]
    });
 
    this.personalInfoForm = this.formBuilder.group({
      favCity: new FormControl("", Validators.required),
      favColor: ["", Validators.required],
      favComposer: ["", [Validators.required]],
      favFood: ["", [Validators.required]],
      favHobby: ["", [Validators.required]],
      favRoleModel: ["", [Validators.required]],
      numberOfSiblings: ["", [Validators.required]],
      relativeInIT: ["", [Validators.required]]
    });

    this.socialMediaForm = this.formBuilder.group({
      socialMediaApps: [""],
      favSocialMedia: ["", [Validators.required, Validators.minLength(3)]],
      favSocialMediaReason: ["", [Validators.required, Validators.minLength(3)]],
      aiToolsUsed: ["", [Validators.required, Validators.minLength(3)]],
      careerVision: ["", [Validators.required, Validators.minLength(3)]]
    });

    this.getUserDetails();
    this.getStates();
    this.getAllCities();
    this.timer();
  }
 
  // convenience getter for easy access to form fields
  get f() {
    return this.userForm.controls;
  }
 
  selectedValue: string;
  selectedCar: string;
 
  onSubmit() {
    this.submitted = true;
 
    // stop here if form is invalid
    if (this.userForm.invalid) {
      return;
    }
 
    alert("SUCCESS!! :-)");
  }
 
  setAll(completed: boolean) {
    this.allComplete = completed;
    if (completed) {
      this.useDifferentAddress = true;
    } else {
      this.useDifferentAddress = false;
    }
  }
 
  getUserDetails() {
   
    this.sessionUserId = sessionStorage.getItem("id");
 
    
 
    this.userDetails.getUserDetails(this.sessionUserId, false).subscribe(
      async data => {
        const result = await data.Datareturned[0];
        
        //extracting address
        const permanentAddressArray = (await result.Permanent_Address)
          ? result.Permanent_Address.split(";")
          : null;
        const presentAddressArray = (await result.Present_Address)
          ? result.Present_Address.split(";")
          : null;
        const state = await this.getState(presentAddressArray);
      
 
        const permanentCityPincode =
          permanentAddressArray !== null
            ? permanentAddressArray[1].split("-")
            : "";
        const presentCityPincode =
          presentAddressArray !== null ? presentAddressArray[1].split("-") : "";
        const permanentState = await this.getState(
          permanentAddressArray
        );
        
 
        const dobValue = result.DOB
          ? moment
              .utc(result.DOB)
              .format("YYYY-MM-DD")
              .toString()
          : null;
        const dob = dobValue !== null ? dobValue.split("-") : "";
        const year = dobValue !== null ? dob[0] : "";
        const month = dobValue !== null ? dob[1] : "";
        const date = dobValue !== null ? dob[2] : "";
      
 
        //extracting school details
        const HigherSecSchoolArray = result.Higher_Secondary_School
          ? data.Datareturned[0].Higher_Secondary_School.split(";")
          : null;
        const highScoolState = await this.getState(
          HigherSecSchoolArray
        );
      
 
        const schooldArray = result.School_Address
          ? data.Datareturned[0].School_Address.split(";")
          : null;
        const schoolState = await this.getState(schooldArray);
        
        const highSchoolCity =
          HigherSecSchoolArray !== null ? HigherSecSchoolArray[1] : "";
        const highSchoolName =
          HigherSecSchoolArray !== null ? HigherSecSchoolArray[0] : "";
 
        const schoolCity = schooldArray !== null ? schooldArray[1] : "";
        const schoolName = schooldArray !== null ? schooldArray[0] : "";
 
        const street =
          presentAddressArray !== null ? presentAddressArray[0] : "";
 
        const city = presentAddressArray !== null ? presentCityPincode[0] : "";
        const pincode =
          presentAddressArray !== null ? presentCityPincode[1] : "";
        const permanentCity =
          permanentAddressArray !== null ? permanentCityPincode[0] : "";
 
        const permanentStreet =
          permanentAddressArray !== null ? permanentAddressArray[0] : "";
        const permanentPincode =
          permanentAddressArray !== null ? permanentCityPincode[1] : "";
 
        //setting basic form value
        this.userForm.setValue({
          name: data.Datareturned[0].Name,
          dob:
            dobValue !== null
              ? new NgbDate(parseInt(year), parseInt(month), parseInt(date))
              : "",
          fatherName: data.Datareturned[0].Father_Name
            ? data.Datareturned[0].Father_Name
            : "",
          fatherOccupation: data.Datareturned[0].Father_Occupation
            ? data.Datareturned[0].Father_Occupation
            : "",
          motherName: data.Datareturned[0].Mother_Name
            ? data.Datareturned[0].Mother_Name
            : "",
          motherOccupation: data.Datareturned[0].Mother_Occupation
            ? data.Datareturned[0].Mother_Occupation
            : ""
        });
 
        //setting address form
        await this.setAddressFormValue(
          street,
          city,
          state,
          pincode,
          permanentStreet,
          permanentCity,
          permanentState,
          permanentPincode
        );
 
        await this.setSchoolDetails(
          result,
          schoolCity,
          schoolName,
          schoolState,
          highSchoolCity,
          highSchoolName,
          highScoolState
        );
 
        //setting personal info
        await this.setPersonalInfo(result);

        //setting social media info
        await this.setSocialMediaInfo(result);
      },
      err => {}
    );
    return this.userDetails;
  }
 
  getStates() {
   
    this.states = State.getStatesOfCountry("IN");

    return this.states;
  }
 
  getAllCities() {
    this.cities = City.getCitiesOfCountry("IN");
    this.permanentCities = City.getCitiesOfCountry("IN");
    this.schoolCities = City.getCitiesOfCountry("IN");
    this.highSchoolCities = City.getCitiesOfCountry("IN");
    return this.cities;
  }
 
  getCities(selectedState: any) {
   
    const state = selectedState.toString();
  
    this.cities = City.getCitiesOfState("IN", state);
 
    return this.cities;
  }
 
  getPermanentCities(selectedState: any) {
    const state = selectedState.toString();
 
    this.permanentCities = City.getCitiesOfState("IN", state);
 
    return this.cities;
  }
 
  getHighSchoolCities(selectedState: any) {
    const state = selectedState.toString();
 
    this.highSchoolCities = City.getCitiesOfState("IN", state);
 
    return this.cities;
  }
 
  getSchoolCities(selectedState: any) {
    const state = selectedState.toString();
 
    this.schoolCities = City.getCitiesOfState("IN", state);
 
    return this.cities;
  }

  // Methods for managing favorite school subjects
  addSchoolSubject() {
    const subject = this.tempSchoolSubject?.trim();
    if (subject && subject.length >= 2 && !this.favSchoolSubjects.includes(subject)) {
      this.favSchoolSubjects.push(subject);
      this.updateSchoolSubjectFormControl();
      this.tempSchoolSubject = "";
    }
  }

  removeSchoolSubject(subject: string) {
    const index = this.favSchoolSubjects.indexOf(subject);
    if (index >= 0) {
      this.favSchoolSubjects.splice(index, 1);
      this.updateSchoolSubjectFormControl();
    }
  }

  updateSchoolSubjectFormControl() {
    const value = this.favSchoolSubjects.join(" | ");
    this.schoolInfoForm.patchValue({ favSchoolSubject: value || "" });
  }

  // Methods for managing favorite college subjects
  addCollegeSubject() {
    const subject = this.tempCollegeSubject?.trim();
    if (subject && subject.length >= 2 && !this.favCollegeSubjects.includes(subject)) {
      this.favCollegeSubjects.push(subject);
      this.updateCollegeSubjectFormControl();
      this.tempCollegeSubject = "";
    }
  }

  removeCollegeSubject(subject: string) {
    const index = this.favCollegeSubjects.indexOf(subject);
    if (index >= 0) {
      this.favCollegeSubjects.splice(index, 1);
      this.updateCollegeSubjectFormControl();
    }
  }

  updateCollegeSubjectFormControl() {
    const value = this.favCollegeSubjects.join(" | ");
    this.schoolInfoForm.patchValue({ favCollegeSubject: value || "" });
  }

  // Methods for managing social media apps
  addSocialMediaApp() {
    const app = this.tempSocialMediaApp?.trim();
    if (app && app.length >= 2 && !this.socialMediaApps.includes(app)) {
      this.socialMediaApps.push(app);
      this.updateSocialMediaFormControl();
      this.tempSocialMediaApp = "";
    }
  }

  removeSocialMediaApp(app: string) {
    const index = this.socialMediaApps.indexOf(app);
    if (index >= 0) {
      this.socialMediaApps.splice(index, 1);
      this.updateSocialMediaFormControl();
    }
  }

  updateSocialMediaFormControl() {
    const value = this.socialMediaApps.join(" | ");
    this.socialMediaForm.patchValue({ socialMediaApps: value || "" });
  }

  // Validation helpers
  isSchoolFormValid(): boolean {
    return this.schoolInfoForm.valid &&
      this.favSchoolSubjects.length > 0 &&
      this.favCollegeSubjects.length > 0;
  }

  isSocialMediaFormValid(): boolean {
    return this.socialMediaForm.valid &&
      this.socialMediaApps.length > 0;
  }

  timer() {
    this.counter = 10 * 60;
    this.countDown = Observable.timer(0, 1000)
      .take(this.counter)
      .map(() => --this.counter);
  }
 
  async submit() {
    this.submitted = true;
    clearTimeout(this.timeout);
    this.time = 0;
    localStorage.setItem(
      `personal[${this.sessionUserId}]`,
      JSON.stringify(this.personalInfoForm.value)
    );
    console.log(
      "Last page details ",
      JSON.stringify(this.personalInfoForm.value)
    );
 
    const res = await this.savePersonalInfoDetails();
 
    if (this.personalDetailsResult.code === 200) {
      Swal.fire({
        title: "",
        text: "Data Saved Sucessfully",
        icon: "success"
      });
    } else {
      Swal.fire({
        title: "",
        text: this.personalDetailsResult.message,
        icon: "warning"
      });
    }
   
   
    this.router.navigateByUrl("/take_snapshot");
 
  }
 
  restrictCommaSemicolon(e) {
    var theEvent = e || window.event;
    var key = theEvent.keyCode || theEvent.which;
    if (key === 188) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) {
        theEvent.preventDefault();
      }
    }
  }
 
  async getStateByISOCode(state) {
    const stateObject = State.getStateByCodeAndCountry(state, "IN");
    console.log("stateObject", stateObject);
    console.log("State object name ", stateObject.name);
    return stateObject.name;
  }
  async parseAddressWhileSubmit() {
    console.log("street", this.addressForm.get("street").value);
    this.updatedAddress = this.addressForm.get("street").value
      ? this.addressForm.get("street").value.replace(/,/g, ";")
      : null;
    const addressState = this.addressForm.get("state").value
      ? await this.getStateByISOCode(this.addressForm.get("state").value)
      : null;
 
    const schoolAddressState = this.schoolInfoForm.get("schoolState").value
      ? await this.getStateByISOCode(
          this.schoolInfoForm.get("schoolState").value
        )
      : null;
    const highSchoolAddressState = this.schoolInfoForm.get("highSchoolState")
      .value
      ? await this.getStateByISOCode(
          this.schoolInfoForm.get("highSchoolState").value
        )
      : null;
    this.address = this.addressForm.get("city").value
      ? `${this.updatedAddress};${this.addressForm.get("city").value}-${
          this.addressForm.get("pincode").value
        };${addressState}`
      : "";
    this.updatedPermanentAddress = this.addressForm.get("permanentStreet").value
      ? this.addressForm.get("permanentStreet").value.replace(/,/g, ";")
      : "";
    if (!this.useDifferentAddress) {
      this.permanentAddress = this.address;
    } else {
      const pmAddressState = this.addressForm.get("permanentState").value
        ? await this.getStateByISOCode(
            this.addressForm.get("permanentState").value
          )
        : "";
      this.permanentAddress = this.updatedPermanentAddress
        ? `${this.updatedPermanentAddress};${
            this.addressForm.get("permanentCity").value
          }-${this.addressForm.get("permanentPincode").value};${pmAddressState}`
        : "";
    }
    console.log("permanentAddress", this.permanentAddress);
    this.school = this.schoolInfoForm.get("schoolName").value
      ? `${this.schoolInfoForm.get("schoolName").value};${
          this.schoolInfoForm.get("schoolCity").value
        };${schoolAddressState}`
      : "";
    this.highSchool = this.schoolInfoForm.get("highSchoolName").value
      ? `${this.schoolInfoForm.get("highSchoolName").value};${
          this.schoolInfoForm.get("highSchoolCity").value
        };${highSchoolAddressState}`
      : "";
  }
 
  async mapValues() {
    const email = sessionStorage.getItem("email");
    this.data.userId = this.sessionUserId;
    this.data.email = email;
    this.data.dob = this.userForm.get("dob").value;
    this.data.fatherName = this.userForm.get("fatherName").value;
    this.data.fatherOccupation = this.userForm.get("fatherOccupation").value;
    this.data.motherName = this.userForm.get("motherName").value;
    this.data.motherOccupation = this.userForm.get("motherOccupation").value;
    this.data.address = this.address;
    this.data.permanentAddress = this.permanentAddress;
    this.data.school = this.school;
    this.data.highScool = this.highSchool;
    this.data.favSchoolSubject = this.schoolInfoForm.get(
      "favSchoolSubject"
    ).value;
    this.data.favCollegeSubject = this.schoolInfoForm.get(
      "favCollegeSubject"
    ).value;
    this.data.favCity = this.personalInfoForm.get("favCity").value;
    this.data.favColor = this.personalInfoForm.get("favColor").value;
    this.data.favComposer = this.personalInfoForm.get("favComposer").value;
    this.data.favFood = this.personalInfoForm.get("favFood").value;
    this.data.favHobby = this.personalInfoForm.get("favHobby").value;
    this.data.favRoleModel = this.personalInfoForm.get("favRoleModel").value;
    this.data.numberOfSiblings = this.personalInfoForm.get(
      "numberOfSiblings"
    ).value;
    this.data.relativeInIT = this.personalInfoForm.get("relativeInIT").value;
    this.data.socialMediaApps = this.socialMediaForm.get("socialMediaApps").value;
    this.data.favSocialMedia = this.socialMediaForm.get("favSocialMedia").value;
    this.data.favSocialMediaReason = this.socialMediaForm.get("favSocialMediaReason").value;
    this.data.aiToolsUsed = this.socialMediaForm.get("aiToolsUsed").value;
    this.data.careerVision = this.socialMediaForm.get("careerVision").value;
    this.data.isFormSubmitted=this.submitted;

    return this.data;
  }
 
  async savePersonalInfoDetails() {
    console.log("inside saving details");
    await this.parseAddressWhileSubmit();
    console.log("Inside save Personal info  function ***");
    await this.mapValues();
    console.log("this.data", this.data);
    const res = this.userDetails
      .insertUserDetails(this.data)
      .subscribe(data => {
        console.log("data 456", data);
        this.personalDetailsResult = data;
       
      });
 
    console.log("Printing this.personal details ", this.personalDetailsResult);
    return this.personalDetailsResult;
  }
 
  // Function to get ISO code of a state by its name
  async getISOCodeOfState(stateName) {
    const countryCode = "IN";
    console.log("inside fetching statename", stateName);
 
    const statesOfCountry = State.getStatesOfCountry(countryCode);
    console.log("states in india", statesOfCountry);
 
    const foundState = statesOfCountry.find(
      state =>
        state.name.replace(/\s/g, "").toLowerCase() ===
        stateName.replace(/\s/g, "").toLowerCase()
    );
 
    if (foundState) {
      console.log(foundState.isoCode, "found state");
      return foundState.isoCode;
    } else {
      return;
    }
  }
 
  async setSchoolDetails(
    data,
    highSchoolCity,
    highSchoolName,
    highSchoolState,
    schoolCity,
    schoolName,
    schoolState
  ) {
    // Parse favorite subjects from database and populate arrays
    const schoolSubjects = data.Favorite_Subject_In_School || "";
    const collegeSubjects = data.Favorite_Subject_In_College || "";

    this.favSchoolSubjects = schoolSubjects ? schoolSubjects.split(" | ").filter(s => s.trim()) : [];
    this.favCollegeSubjects = collegeSubjects ? collegeSubjects.split(" | ").filter(s => s.trim()) : [];

    this.schoolInfoForm.setValue({
      favCollegeSubject: data.Favorite_Subject_In_College
        ? data.Favorite_Subject_In_College
        : "",
      favSchoolSubject: data.Favorite_Subject_In_School
        ? data.Favorite_Subject_In_School
        : "",
      highSchoolCity: highSchoolCity,
      highSchoolName: highSchoolName,
      highSchoolState: highSchoolState !== null ? highSchoolState : "",
      schoolCity: schoolCity,
      schoolName: schoolName,
      schoolState: schoolState !== null ? schoolState : ""
    });
  }
 
  async setPersonalInfo(data) {
    console.log("DATA", data);
    this.personalInfoForm.setValue({
      favCity: data.Favorite_City ? data.Favorite_City : "",
      favColor: data.Favorite_Color ? data.Favorite_Color : "",
      favComposer: data.Favorite_Music_Composer
        ? data.Favorite_Music_Composer
        : "",
      favFood: data.Favorite_Food ? data.Favorite_Food : "",
      favHobby: data.Favorite_Hobby ? data.Favorite_Hobby : "",
      favRoleModel: data.Role_Model ? data.Role_Model : "",
      numberOfSiblings: data.Number_Of_Siblings ? data.Number_Of_Siblings : 0,
      relativeInIT: data.Close_Relative_Working_In_IT_Industry
        ? data.Close_Relative_Working_In_IT_Industry
        : ""
    });
  }

  async setSocialMediaInfo(data) {
    // Parse social media apps from database and populate array
    const apps = data.Social_Media_Apps || "";
    this.socialMediaApps = apps ? apps.split(" | ").filter(a => a.trim()) : [];

    this.socialMediaForm.setValue({
      socialMediaApps: data.Social_Media_Apps ? data.Social_Media_Apps : "",
      favSocialMedia: data.Favorite_Social_Media ? data.Favorite_Social_Media : "",
      favSocialMediaReason: data.Favorite_Social_Media_Reason ? data.Favorite_Social_Media_Reason : "",
      aiToolsUsed: data.AI_Tools_Used ? data.AI_Tools_Used : "",
      careerVision: data.Career_Vision_5_Years ? data.Career_Vision_5_Years : ""
    });
  }

  async setAddressFormValue(
    street,
    city,
    state,
    pincode,
    permanentStreet,
    permanentCity,
    permanentState,
    permanentPincode
  ) {
    this.addressForm.setValue({
      street: street,
      city: city,
      state: state !== null ? state : "",
      pincode: pincode,
      permanentStreet: permanentStreet,
      permanentCity: permanentCity,
      permanentState: permanentState !== null ? permanentState : "",
      permanentPincode: permanentPincode
    });
  }
 

 
  async getState(inputArray) {
    console.log("IN Middle school array", inputArray);
    if (inputArray !== null) {
      const result = await this.getISOCodeOfState(inputArray[2]);
      console.log("middle school state", result);
      return result;
    } else {
      return null;
    }
  }
}
 
